import React, { FunctionComponent } from "react"
import { Grid } from "@material-ui/core"
import { useBatchPageContext } from "./useBatchPageContext"
import { BatchTable } from "./BatchTable"
import { Upload } from "./Upload"
import { useStepControlsContext } from "../../features/StepControls/useStepControlsContext"

export const BatchPageContent: FunctionComponent = props => {
    const { state } = useBatchPageContext()
    const { state: stepper } = useStepControlsContext()
    return (
        <>
            <Grid item>{stepper.activeStep === 0 && <Upload />}</Grid>
            <Grid item>
                {state.batchItems.length > 0 && <BatchTable rows={state.batchItems} />}
            </Grid>
        </>
    )
}
